import { Box, Button, Chip, CircularProgress, Stack, Typography } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';

// FEAT-003 SaveBufferIndicator — 변경 누적 카운트 + 저장 버튼.
// 결정 9 (로컬 buffer + 일괄 PR) + 결정 10 (MatrixPage 가 buffer state 보유).
//
// Props:
//   changeCount : 변경된 Feature 개수 (원본 vs 현재 buffer diff)
//   saving      : 저장 중 boolean
//   onSave      : 저장 버튼 핸들러 (saveFeatures API 호출)
export default function SaveBufferIndicator({ changeCount, saving, onSave }) {
  if (changeCount === 0 && !saving) {
    return (
      <Box sx={{ mb: 2 }}>
        <Typography variant="caption" sx={{ color: 'text.disabled' }}>
          저장하지 않은 변경 없음
        </Typography>
      </Box>
    );
  }
  return (
    <Stack
      direction="row"
      spacing={2}
      alignItems="center"
      sx={{
        mb: 2,
        p: 1.5,
        bgcolor: 'warning.light',
        borderRadius: 1,
        border: 1,
        borderColor: 'warning.main',
      }}
    >
      <Chip
        label={`변경 ${changeCount}건`}
        color="warning"
        size="small"
      />
      <Typography variant="caption" sx={{ flexGrow: 1, color: 'text.primary' }}>
        저장하지 않은 변경 사항이 있습니다. "저장" 클릭 시 main 에 직접 반영됩니다 (~3초).
      </Typography>
      <Button
        variant="contained"
        size="small"
        startIcon={saving ? <CircularProgress size={16} color="inherit" /> : <SaveIcon />}
        onClick={onSave}
        disabled={saving || changeCount === 0}
      >
        {saving ? '저장 중...' : '저장 → PR 생성'}
      </Button>
    </Stack>
  );
}
